import { render, staticRenderFns } from "./PreviewSetButton.vue?vue&type=template&id=0532ba2e&scoped=true&functional=true&"
import script from "./PreviewSetButton.vue?vue&type=script&lang=ts&"
export * from "./PreviewSetButton.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewSetButton.vue?vue&type=style&index=0&id=0532ba2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0532ba2e",
  null
  
)

export default component.exports